// removed by extract-text-webpack-plugin
module.exports = {"navigation-home-side":"index__navigation-home-side___2Xo-l","navigationHomeSide":"index__navigation-home-side___2Xo-l","logo":"index__logo___3KBs3","page-wrapper":"index__page-wrapper___1221q","pageWrapper":"index__page-wrapper___1221q","link":"index__link___3CZk8","active":"index__active___26D8c","is-browser":"index__is-browser___ltUDO","isBrowser":"index__is-browser___ltUDO","mobile-device":"index__mobile-device___19Dy5","mobileDevice":"index__mobile-device___19Dy5","page":"index__page___nxA-0","extra-item":"index__extra-item___wEZFX","extraItem":"index__extra-item___wEZFX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/NavigationSide/index.css
// module id = 731
// module chunks = 12